module.exports = __webpack_public_path__ + "static/media/image75.c76aa4d0.png";